export function authHeader() {
  let user_token = localStorage.getItem("user_auth_token");
  return "Bearer " + user_token;
}
